var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('b-loading',{attrs:{"active":!_vm.iiifUrl && !_vm.xmlJson}}),(_vm.iiifUrl && _vm.xmlJson)?_c('div',[_c('TranscriptionInterfaceLocal',{attrs:{"iiifUrl":_vm.iiifUrl,"xmlJson":_vm.xmlJson}})],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }